import { useNetworkStatus } from '@/hooks/useNetworkStatus';
import { FC, memo, useMemo } from 'react';

import { useDefaultPagination } from '../hooks/useJournalEntries';
import { JournalInfoTable, type InternalTableProps } from './JournalInfoTable';

type ErrorJournalInfoTableProps = {
  error: Error | null;
};

export const ErrorJournalInfoTable: FC<ErrorJournalInfoTableProps> = memo(
  () => {
    const pagination = useDefaultPagination();
    const tableProps = useMemo(
      () => ({ data: [], loading: false, emptyType: 'error' as const }),
      []
    );
    return <JournalInfoTable table={tableProps} pagination={pagination} />;
  }
);
ErrorJournalInfoTable.displayName = 'ErrorJournalInfoTable';

export const LoadingJournalInfoTable: FC = memo(() => {
  const isOnline = useNetworkStatus();
  const pagination = useDefaultPagination();
  const tableProps = useMemo(
    () => ({ data: [], loading: isOnline }),
    [isOnline]
  );
  return <JournalInfoTable table={tableProps} pagination={pagination} />;
});
LoadingJournalInfoTable.displayName = 'LoadingJournalInfoTable';

export type { InternalTableProps };
